module.exports = __webpack_public_path__ + "static/media/gha.04e9ecf6.svg";